import { createReducer, on } from '@ngrx/store';
import { ContentPage, PageData } from '../../models';
import * as pageActions from '../actions/content-pages.action';
import * as utility from '../../../utility';

export interface ContentPagesState {
  entities: { [id: number]: ContentPage };
  overview: { [id: number]: ContentPage };
  subPages: { [id: number]: ContentPage };
  loaded: boolean;
  loading: boolean;
  subPagesloaded: boolean;
  subPagesloading: boolean;
  overviewLoaded: boolean;
  overviewLoading: boolean;
  error?: any;
  page: PageData;
}

export const initialState: ContentPagesState = {
  entities: {},
  overview: {},
  subPages: {},
  loaded: false,
  loading: false,
  subPagesloaded: false,
  subPagesloading: false,
  overviewLoaded: false,
  overviewLoading: false,
  page: { current: 0, pageCount: 0, resultCount: 0, size: 12 },
};

export const contentPageReducer = createReducer(
  initialState,
  on(pageActions.LoadContentPages, (state: ContentPagesState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(pageActions.LoadContentPagesSuccess, (state: ContentPagesState, { contentPages }) => {
    const entities = utility.ToEntities(contentPages, 'id', state.entities);
    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
    };
  }),
  on(pageActions.LoadContentPagesFail, (state: ContentPagesState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  }),
  on(pageActions.LoadSubContentPages, (state: ContentPagesState) => {
    return {
      ...state,
      subPagesloading: true,
    };
  }),
  on(pageActions.LoadSubContentPagesSuccess, (state: ContentPagesState, { contentPages }) => {
    const subPages = utility.ToEntities(contentPages, 'id', state.entities);
    return {
      ...state,
      subPages,
      subPagesloading: false,
      subPagesloaded: true,
    };
  }),
  on(pageActions.LoadSubContentPagesFail, (state: ContentPagesState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  }),
  on(pageActions.ClearSubPages, (state: ContentPagesState) => {
    return {
      ...state,
      subPagesloading: false,
      subPagesloaded: false,
      subPages: {},
    };
  })
);

export const getContentPagesEntities = (state: ContentPagesState) => state.entities;
export const getContentPagesLoading = (state: ContentPagesState) => state.loading;
export const getContentPagesLoaded = (state: ContentPagesState) => state.loaded;

export const getSubContentPagesEntities = (state: ContentPagesState) => state.subPages;
export const getSubContentPagesLoading = (state: ContentPagesState) => state.subPagesloading;
export const getSubContentPagesLoaded = (state: ContentPagesState) => state.subPagesloaded;
